module.exports = __webpack_public_path__ + "img/logo_hbs.4cd325a9.jpg";